module.exports = __webpack_public_path__ + "img/bsjg_04.d083e8a9.png";